import { render, staticRenderFns } from "./SideBarCategoryFilter.vue?vue&type=template&id=7bd597fc&"
import script from "./SideBarCategoryFilter.vue?vue&type=script&lang=js&"
export * from "./SideBarCategoryFilter.vue?vue&type=script&lang=js&"
import style0 from "./SideBarCategoryFilter.vue?vue&type=style&index=0&id=7bd597fc&prod&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports